<template>
  <svg
    version="1.1"
    id="レイヤー_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
    style="enable-background: new 0 0 24 24"
    xml:space="preserve"
  >
    <circle
      id="楕円形_1"
      :style="{
        fill: colors[0],
      }"
      cx="12"
      cy="12"
      r="12"
    />
    <g>
      <g>
        <defs>
          <circle id="SVGID_1_" cx="12" cy="12" r="12" />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlink:href="#SVGID_1_" style="overflow: visible" />
        </clipPath>
        <g
          id="マスクグループ_1"
          :style="{
            fill: colors[1],
          }"
        >
          <g id="グループ_50" transform="translate(9.822 14.563)" class="st2">
            <path
              id="パス_88"
              class="st3"
              d="M5.5-5.7v-3.5h-6.6v7.6h-5v11h16.7V-5.7H5.5z M-2.6,6.9h-1.3V5.3h1.3L-2.6,6.9z M-2.6,2.9
					h-1.3V1.2h1.3L-2.6,2.9z M2.8,7H1.5V5.4h1.3V7z M2.8,2.9H1.5V1.3h1.3V2.9z M2.8-1.1H1.5v-1.6h1.3V-1.1z M2.8-5.1H1.5v-1.6h1.3
					V-5.1z M8.1,6.9H6.9V5.3h1.3V6.9z M8.1,2.9H6.9V1.2h1.3V2.9z M8.1-1.2H6.9v-1.6h1.3V-1.2z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'account',
    props: {
      size: {
        type: Number,
        default: 20,
      },
      colors: {
        type: Array,
        default: () => ['#6F6F6F', '#FFFFFF'],
      },
    },
  };
</script>
<style scoped>
  .st1 {
    clip-path: url(#SVGID_2_);
  }
  .st2 {
    opacity: 0.494;
  }
</style>
